module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page) ? _c('section', {
    staticClass: "pageHero",
    class: _vm.colorScheme
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.page.image) ? _c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url(" + _vm.featuredImage + ")")
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hero-content"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.hero.title)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.hero.lead)
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22a08ff6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Hero.vue
// module id = 766
// module chunks = 1